import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "./header/Header";
import Sidebar from "./sidebar/Sidebar";

const WithNavbar = ({setIsAuthen}) => {
    const [hideSidebar, setHideSidebar] = useState(false)
    const handleCompressSidebar = () => {
        setHideSidebar(!hideSidebar);
    }
  return (
    <div className="home">
      <div className={`home_sidebar ${hideSidebar ? 'sidetoggle' : null}`}>
        <Sidebar hideSidebar = {hideSidebar} handleCompressSidebar={handleCompressSidebar} />
      </div>
      <div className={`home_container ${hideSidebar ? 'containertoggle' : null}`}>
        <div className="home_container-header">
          <Header setIsAuthen={setIsAuthen} />
        </div>


        <div className="home_container-routes">
          <Outlet />
        </div>


      </div>
    </div>
  );
};

export default WithNavbar;
